import { CrashReportTrigger } from 'lib/gql/queryTypes';

export const formatSize = (size: number): string => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatCrashReportTrigger = (
  trigger: CrashReportTrigger
): string => {
  switch (trigger) {
    case CrashReportTrigger.ProcessCrashed:
      return 'Process crashed';
    case CrashReportTrigger.UserCrashed:
      return 'User crashed';
    case CrashReportTrigger.UserManuallyRestarted:
      return 'User manually restarted';
  }
};
